import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';

class FilterDef {
    selectedData;
    label;
    path;
    type;
    //options;

    constructor(props) {
        const { displayKey, key, path, type } = props;
        this.label = displayKey ?? type;
        this.path = path ?? key;
        this.type = type;
    }

    // return true to include in results
    filter(row) {
        // override in derived classes
    }

    hasSelectedValue() {}

    getSelectedValue() {}

    setSelectedData(data) {
        this.selectedData = data;
    }

    clearSelectedData() {
        let a;
        this.selectedData = a;
    }
}

export class SelectFieldFilterDef extends FilterDef {
    options;
    constructor(props) {
        super(props);
        let options = props?.options ?? [];
        this.options = options.map((o) => {
            if (typeof o === 'string' || typeof o === 'number') {
                // turn into an object meeting the appropriate criteria
                return { name: o, displayKey: o.toString() };
            }
            if (!o.name) {
                o.name = o.displayKey;
            }
            if (!o.displayKey) {
                o.displayKey = o.name;
            }
            return o;
        });
    }

    filter(row) {
        const { selectedData = [] } = this;
        if (isEmpty(selectedData)) {
            return true;
        }
        //console.log(selectedData);
        // const testValues = Object.entries(selectedData)
        //     .map(([key, checked]) => (checked ? key : null))
        //     .filter((k) => k);
        //const testValues = selectedData ?? [];
        if (!selectedData?.length) {
            return true;
        }
        //const testValues = isArray(selectedData) ? selectedData : [selectedData];
        // todo what is path is not in data?
        // todo handle multi selection

        const fieldValue = get(row, this.path);
        if (!fieldValue) {
            return false;
        }
        const fieldValues = isArray(fieldValue) ? fieldValue : [fieldValue];

        //return testValues.includes(fieldValue);
        return fieldValues.some((v) => selectedData.includes(v));
    }

    // toggle option and return new selected data
    toggleOption(optionName, checked) {
        const { selectedData = [], options } = this;
        const newSelectedData = checked
            ? [optionName, ...selectedData]
            : selectedData.filter((o) => o !== optionName);
        this.selectedData = newSelectedData;
        return newSelectedData;
    }

    // return options with their checked status
    // todo better name?
    getOptionsWithValues() {
        const { selectedData = [], options } = this;
        return options.map((o) => {
            o.checked = selectedData.includes(o.name);
            return o;
        });
    }

    hasSelectedValue() {
        const { selectedData } = this;
        return !!selectedData?.length;
    }
}

export class CustomFilterDef extends FilterDef {
    label;
    path;
    type;
    filterFn;

    constructor(props) {
        super(props);
        this.filterFn = props.filterFn;
    }

    filter(row) {
        return this.filterFn(row, this.selectedData);
    }
}
